import React from "react";
import { NavLink } from "react-router-dom";
import { inject, observer } from "mobx-react";

@inject("userStore")
@observer
export default class HeaderItem extends React.Component {
    render() {
        const {name, link, allowedRole, userStore} = this.props

        const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";
        let showItem = true; //show this component by default
        if(allowedRole) showItem = !IS_BIRD_APP && allowedRole && userStore.hasUserTheGivenRole(allowedRole)
        return showItem ? (
            <li>
            <NavLink activeclassname="active" to={link}>
                {name}
            </NavLink>
            </li>
        ) : null
    }
}